import { useEffect, useState } from "react";
import { formatCurrency, returnPractice } from "../../../../lib/script";

import classes from './SelfPayItemPractice.module.css'
import HoverWrapperInfo from "../../../wrappers/HoverWrapperInfo";
import DisplayBoxRight from "../../../fragments/DisplayBoxRight";
export default function SelfPayItemPracticeV2({case_practice, selfPay}) {

    const [practiceSystem, setPracticeSystem] = useState(null)

    const [monthNotPaid, setMonthNotPaid] = useState(false)

    useEffect(() => {
        setPracticeSystem(returnPractice(case_practice.practice_id))
    }, [])

    return <tr className={monthNotPaid ? classes.not_paid : ''}>
        <td>
            {monthNotPaid && <HoverWrapperInfo modalText={['Missed a payment!']}>
                <i className="ti ti-info-square"></i> 
            </HoverWrapperInfo>}
            {practiceSystem?.name}
        </td>
        <td>
            <DisplayBoxRight>
                {case_practice?.selfpay_amount_balance ? `$${formatCurrency(case_practice?.selfpay_amount_balance)}` : ''}
            </DisplayBoxRight>
        </td>
        <td>
            <DisplayBoxRight>
                {case_practice?.balance ? `$${formatCurrency(case_practice?.balance)}` : ''}
            </DisplayBoxRight>
        </td>
        <td>
            <DisplayBoxRight>
                ${formatCurrency(case_practice?.selfpay_amount_balance - case_practice?.balance)}
            </DisplayBoxRight>
        </td>
        <td>
            <DisplayBoxRight>
                ${formatCurrency((case_practice?.selfpay_amount_balance * selfPay.monthly_payment) / selfPay.total_balance)}    
            </DisplayBoxRight>
        </td>
    </tr>
}